import { useQuery } from "react-query";

import { queryKeys } from "../../../queries/keys";
import { getHomeCoordinatorProjects, getHomeTracking } from "../api/home.api";
import type { HomeScope } from "../types/home.types";
import { HOME_FRESH_QUERY } from "./useHomeSummary";

const TRACKING_REFRESH_MS = 60 * 1000;

/**
 * Fases, carga e movimentações do Início. Como os indicadores, trocar o
 * escopo só troca a chave: recalcula sem recarregar a página.
 */
export function useHomeTracking(scope?: HomeScope) {
  return useQuery(queryKeys.homeTracking(scope), () => getHomeTracking(scope), {
    ...HOME_FRESH_QUERY,
    keepPreviousData: true,
    // A troca de status só vira movimentação quando a fila de auditoria roda
    // (cron a cada 2 min); com a tela aberta, ela aparece sem recarregar.
    refetchInterval: TRACKING_REFRESH_MS,
  });
}

/** Projetos do coordenador, buscados só quando a linha é expandida. */
export function useHomeCoordinatorProjects(
  scope: HomeScope,
  coordinator: string
) {
  return useQuery(
    queryKeys.homeCoordinatorProjects(scope, coordinator),
    () => getHomeCoordinatorProjects(scope, coordinator),
    HOME_FRESH_QUERY
  );
}
